import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Portfolio.css";
import hipofyImg from "../assets/hipofy.png";
import hipofyImg1 from "../assets/hipofy1.png";
import coloraiImg from "../assets/colorai.png";
import coloraiImg1 from "../assets/colorai1.png"; 
import coloraiImg2 from "../assets/colorai2.png";
import Logo26 from "../assets/Logo26.png";
import { FaLinkedin } from "react-icons/fa";

const experiences = [
	{
        puesto: "Estudiante/Desarrollador",
		empresa: "42 Fundación Telefónica",
		periodo: "Febrero 2025 - Actualidad",
		descripcion: "Formación práctica intensiva en programación y desarrollo de software en el campus 42. Trabajo en proyectos colaborativos, resolución de retos de código y aprendizaje autodidacta en C, Shell, Python, algoritmia y desarrollo web.",
		},
	{
        puesto: "Desarrollador Frontend",
		empresa: "ColorAi",
		periodo: "Enero 2025 - junio 2025",
		descripcion: "Desarrollo del Front-End de una aplicacion multiplataforma con React Native, Expo, Redux, HTML5, CSS3, Javascript (ES6+). Mejoras de componentes, diseño y usabilidad.",
	},
	{
        puesto: "Desarrollador Full Stack",
		empresa: "Hipofy",
		periodo: "Septiembre 2023 - abril 2024",
		descripcion: "Diseño y desarrollo del Front-end utilizando tecnologías web como HTML5, CSS3, Javascript (ES6+) y React. Implementación y mantenimiento efectivo del Back-end utilizando MongoDB,Node.js y Express.js.",
		},
	{
		puesto: "Bootcamp de Programación",
		empresa: "CODE SPACE Academy",
		periodo: "Febrero 2023 - Julio 2023",
		descripcion: "Formación intensiva en desarrollo web Full-Stack. Aprendizaje práctico de HTML, CSS, JavaScript, React, Express, Node.js, trabajando en proyectos reales y colaborativos.",
	
    },
];

const projects = [
    {
        id: 3,
        name: "501 Dart League",
        shortDescription: "Plataforma Full Stack de dardos — +300 usuarios, 7 ligas activas, sala online",
        description: "Proyecto profesional desarrollado íntegramente desde cero. App móvil nativa en Google Play Store + plataforma web, conectadas a un backend propio en Railway con MongoDB Atlas.\n\nGestión completa de ligas y campeonatos con brackets en tiempo real, estadísticas detalladas por jugador, modo multijugador online con Socket.IO y entrenamiento de cierres. Arquitectura con JWT, roles, caché inteligente y +30 tests automatizados. En uso activo en campeonatos oficiales de Andalucía.",
        images: [Logo26],
        technologies: ["React Native", "JavaScript", "CSS", "Expo", "Node.js", "MongoDB", "Express"],
        hasWebApp: true,
        featured: true,
        playStoreUrl: "https://play.google.com/store/apps/details?id=com.dartsgame.esp501",
    },
    {
        id: 2,
        name: "ColorAi",
        shortDescription: "Asesor de imagen inteligente con IA.",
        description: "ColorAI es una aplicación diseñada para identificar con precisión los colores de ropa, accesorios, cosméticos y tonos de cabello que más favorecen a tus clientes. Utilizando inteligencia artificial, analiza los pigmentos de la piel, las facciones y las proporciones faciales para ofrecer recomendaciones de productos personalizadas y adaptadas a cada usuario. La app está en producción y se encuentra disponible en Google Play, aunque solo puede utilizarse mediante acceso privado con pago/licencia.🔒 Por motivos de confidencialidad, no puedo mostrar el código fuente ni una demo pública. ✅ Proyecto profesional, en uso real por clientes.",
        images: [coloraiImg, coloraiImg1,coloraiImg2],
        technologies: ["React Native", "JavaScript", "HTML5", "CSS3", "Redux", "Expo"],
    },
    {
        id: 1,
        name: "Hipofy",
        shortDescription: "App web y móvil para gestionar listas de la compra y comparar precios.",
        description: "Aplicacion web para ahorrar en la lista de la compra, con funcionalidades de registro, inicio de sesión, creación de listas y productos, comparación de precios en diferentes supermercados. una vez desrrollado en Web, se adptó a una aplicación móvil.",
        images: [hipofyImg, hipofyImg1],
        technologies: ["React", "Node.js", "HTML5", "CSS3", "MongoDB", "Express" ],
    },
];

const Modal = ({ show, onClose, project }) => {
    const [zoomImg, setZoomImg] = useState(null);

    if (!show || !project) return null;
    return (
        <>
            <div className="modal-overlay" onClick={onClose}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <button
                        className="modal-close"
                        onClick={onClose}
                        style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            fontSize: "1.5rem",
                            background: "none",
                            border: "none",
                            color: "#61DBFB",
                            cursor: "pointer",
                        }}
                    >
                        ✖
                    </button>
                    <h2>{project.name}</h2>
                    <div
                        className="modal-images"
                        style={{
                            display: "flex",
                            gap: "1rem",
                            justifyContent: "center",
                            margin: "1rem 0",
                        }}
                    >
                        {project.images && project.images.some(img => img) ? (
                            project.images.map(
                                (img, idx) =>
                                    img && (
                                        <img
                                            key={idx}
                                            src={img}
                                            alt={project.name + " " + (idx + 1)}
                                            style={{
                                                maxWidth: "180px",
                                                borderRadius: "12px",
                                                boxShadow: "0 2px 12px #0077ff44",
                                                cursor: "zoom-in"
                                            }}
                                            onClick={() => setZoomImg(img)}
                                        />
                                    )
                            )
                        ) : (
                            <>
                                <span style={{ fontSize: "4rem" }} role="img" aria-label="imagen">🖼️</span>
                                <span style={{ fontSize: "4rem" }} role="img" aria-label="imagen">🖼️</span>
                            </>
                        )}
                    </div>
                    {project.name === "501 Dart League" ? (
                        <div className="dart-features">
                            <p style={{ fontSize: '1.05rem', marginBottom: '1rem', lineHeight: '1.6' }}>
                                Proyecto Full Stack profesional desarrollado íntegramente desde cero. App móvil nativa en Google Play Store + plataforma web, conectadas a un backend propio en Railway con MongoDB Atlas.
                            </p>
                            <div className="feature-grid">
                                <div className="feature-item"><span className="feature-icon">🏆</span><span>Ligas completas con jornadas, clasificaciones y emparejamientos</span></div>
                                <div className="feature-item"><span className="feature-icon">🎯</span><span>Campeonatos con brackets eliminatorios en tiempo real</span></div>
                                <div className="feature-item"><span className="feature-icon">📊</span><span>Estadísticas detalladas: media, % cierre, historial</span></div>
                                <div className="feature-item"><span className="feature-icon">🌐</span><span>Multijugador online: lobby, retos y partidas en vivo</span></div>
                                <div className="feature-item"><span className="feature-icon">🔐</span><span>JWT, roles, caché inteligente y +30 tests</span></div>
                                <div className="feature-item"><span className="feature-icon">📱</span><span>En uso en campeonatos oficiales de Andalucía</span></div>
                            </div>
                        </div>
                    ) : (
                        <p className="modal-description">{project.description}</p>
                    )}
                    {project.name === "501 Dart League" && (
                        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: "1rem" }}>
                            {project.hasWebApp && (
                                <Link
                                    to="/501DartLeague"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        background: "linear-gradient(135deg, #00C6CF 0%, #0099CC 100%)",
                                        color: "#fff",
                                        padding: "1rem 2rem",
                                        borderRadius: "12px",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                        fontSize: "1.15rem",
                                        boxShadow: "0 4px 20px rgba(0, 198, 207, 0.4)",
                                        transition: "all 0.3s",
                                        flex: "1",
                                        minWidth: "200px",
                                        justifyContent: "center"
                                    }}
                                    className="dart-app-btn"
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-3px)";
                                        e.currentTarget.style.boxShadow = "0 6px 30px rgba(0, 198, 207, 0.6)";
                                        e.currentTarget.style.background = "linear-gradient(135deg, #00d4e0 0%, #00a3d9 100%)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(0, 198, 207, 0.4)";
                                        e.currentTarget.style.background = "linear-gradient(135deg, #00C6CF 0%, #0099CC 100%)";
                                    }}
                                >
                                    🎯 Acceder a la Web App
                                </Link>
                            )}
                            {project.playStoreUrl && (
                                <a
                                    href={project.playStoreUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        background: "#01875f",
                                        color: "#fff",
                                        padding: "1rem 2rem",
                                        borderRadius: "12px",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                        fontSize: "1.15rem",
                                        boxShadow: "0 4px 20px rgba(1, 135, 95, 0.4)",
                                        transition: "all 0.3s",
                                        flex: "1",
                                        minWidth: "200px",
                                        justifyContent: "center"
                                    }}
                                    className="playstore-btn"
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-3px)";
                                        e.currentTarget.style.boxShadow = "0 6px 30px rgba(1, 135, 95, 0.6)";
                                        e.currentTarget.style.background = "#019e6d";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(1, 135, 95, 0.4)";
                                        e.currentTarget.style.background = "#01875f";
                                    }}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                                    </svg>
                                    Descargar en Play Store
                                </a>
                            )}
                        </div>
                    )}
                    {project.name === "501 Dart League" && project.hasWebApp && (
                        <div style={{ display: "none" }}></div>
                    )}
                    {project.name === "ColorAi" && (
                        <a
                            href="https://www.linkedin.com/company/color-ai/posts/?feedView=all"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                background: "#0A66C2",
                                color: "#fff",
                                padding: "0.5rem 1.2rem",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                textDecoration: "none",
                                margin: "1rem 0",
                                fontSize: "1.08rem",
                                boxShadow: "0 2px 8px #0A66C244",
                                transition: "background 0.2s"
                            }}
                            className="linkedin-btn"
                        >
                            <FaLinkedin size={22} />
                            Ver en LinkedIn
                        </a>
                    )}
                    {project.name === "Hipofy" && (
                        <a
                            href="https://github.com/Juanmi7/Hipofy"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                background: "#24292e",
                                color: "#fff",
                                padding: "0.5rem 1.2rem",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                textDecoration: "none",
                                margin: "1rem 0",
                                fontSize: "1.08rem",
                                boxShadow: "0 2px 8px #24292e44",
                                transition: "background 0.2s"
                            }}
                            className="github-btn"
                        >
                            <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" style={{ marginRight: "0.3rem" }}>
                                <path d="M12 0C5.37 0 0 5.373 0 12c0 5.303 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.84 1.237 1.84 1.237 1.07 1.834 2.809 1.304 3.495.997.108-.775.418-1.305.76-1.605-2.665-.305-5.466-1.334-5.466-5.931 0-1.31.469-2.381 1.236-3.221-.124-.303-.535-1.523.117-3.176 0 0 1.008-.322 3.301 1.23a11.52 11.52 0 0 1 3.003-.404c1.019.005 2.047.138 3.003.404 2.291-1.553 3.297-1.23 3.297-1.23.653 1.653.242 2.873.119 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.803 5.624-5.475 5.921.43.371.813 1.102.813 2.222v3.293c0 .322.218.694.825.576C20.565 21.796 24 17.299 24 12c0-6.627-5.373-12-12-12z"/>
                            </svg>
                            Ver código en GitHub
                        </a>
                    )}
                    <div className="modal-tech">
                        <strong>Tecnologías usadas:</strong>
                        <ul
                            style={{
                                display: "flex",
                                gap: "0.5rem",
                                flexWrap: "wrap",
                                listStyle: "none",
                                padding: 0,
                                margin: "0.5rem 0 0 0",
                            }}
                        >
                            {project.technologies.map((tech, idx) => (
                                <li
                                    key={idx}
                                    style={{
                                        background: "#0077ff22",
                                        borderRadius: "6px",
                                        padding: "0.3rem 0.7rem",
                                        fontSize: "0.95rem",
                                    }}
                                >
                                    {tech}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            {/* Overlay para imagen ampliada */}
            {zoomImg && (
                <div
                    onClick={() => setZoomImg(null)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.85)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10000,
                        cursor: "zoom-out"
                	}}
                >
                    <img
                        src={zoomImg}
                        alt="Imagen ampliada"
                        style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            borderRadius: "18px",
                            boxShadow: "0 8px 32px #0077ff88"
                        }}
                    />
                </div>
            )}
        </>
    );
};

const gameInfo = {
    name: "Juego Phaser",
    shortDescription: "Minijuego Web desarrolado en JavaScript con Phaser",
    description: "Como amante de los videojuegos y movido por mi curiosidad, siempre quise saber cómo se mueve un juego a nivel de código. Al descubrir Phaser con JavaScript, me lancé a desarrollar mi primer minijuego, una experiencia totalmente nueva para mí. En él, ayudas a mi personaje a recoger certificados y diplomas mientras esquiva al virus de la duda, esa barrera interna que todos enfrentamos al buscar un nuevo reto profesional.",
};

const GAME_VERSION = "1.0.1"; 

const Portfolio = () => {
    const [modalProject, setModalProject] = useState(null);
    const [showGame, setShowGame] = useState(false);
    const [screenMsg, setScreenMsg] = useState("");

    useEffect(() => {
        const checkScreen = () => {
            if (window.innerHeight < 450) {
               setScreenMsg("Este dispositivo no cumple con el tamaño mínimo recomendado (800x600). Disculpa las molestias. Se recomienda acceder desde un ordenador o una tablet para una mejor experiencia.");
            } else if (window.innerWidth < 700 || window.innerHeight < 400) {
                setScreenMsg("¡Ups! Este juego está diseñado para pantallas más grandes. Parece que estás usando una pantalla reducida. Prueba a girar tu dispositivo para mejorar la experiencia.");
            } else {
                setScreenMsg("");
            }
        };
        checkScreen();
        window.addEventListener("resize", checkScreen);
        return () => window.removeEventListener("resize", checkScreen);
    }, []);

    const handleDownloadCV = () => {
        const link = document.createElement("a");
        link.href = "/cv.pdf";
        link.download = "cv.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <div className="portfolio">
                <h2 className="experience-title" id="experience">
                    Experiencia
                </h2>
                <div className="experience">
                    {experiences.map((exp, idx) => (
                        <div key={idx} className="experience-item">
                            <h3>
                                {exp.puesto} -{" "}
                                <span style={{ fontWeight: "normal" }}>{exp.empresa}</span>
                            </h3>
                            <p className="periodo">{exp.periodo}</p>
                            <p>{exp.descripcion}</p>
                        </div>
                    ))}
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <button
                            type="button"
                            className="cv-download-btn"
                            onClick={handleDownloadCV}
                        >
                            Descargar CV 📄
                        </button>
                    </div>
                </div>
                <h2 className="experience-title2" id="projects">
                    Proyectos
                </h2>
                <ul>
                    {projects.map((project) => (
                        <li
                            key={project.id}
                            className={project.featured ? 'featured-project' : ''}
                            style={{ cursor: "pointer" }}
                            onClick={() => setModalProject(project)}
                        >
                            <h3>{project.name}</h3>
                            <p>{project.shortDescription}</p>
                        </li>
                    ))}
                </ul>
                <h2 className="experience-title2" id="juego">
                    Juego
                </h2>
                <ul>
                    <li
                        className={showGame ? "game-card no-hover" : "game-card"}
                        style={{
                            width: showGame ? "820px" : "320px",
                        }}
                    >
                        <h3>{gameInfo.name}</h3>
                        {!showGame && (
                            <p>{gameInfo.shortDescription}</p>
                        )}
                        <button
                            onClick={() => setShowGame((prev) => !prev)}
                            className="cv-download-btn"
                            style={{ marginTop: "1rem" }}
                        >
                            {showGame ? "Cerrar juego" : "Jugar 🎮"}
                        </button>
                        {showGame && (
                            <>
                                <p style={{ fontSize: "0.98rem", marginTop: "1rem", marginLeft: "2rem", marginRight: "2rem" }}>
                                    {gameInfo.description}
                                </p>
                                {screenMsg ? (
                                    <div style={{ textAlign: "center", margin: "2rem 0" }}>
                                        <span style={{ fontSize: "4rem", display: "block" }}>📱🔄</span>
                                        <p style={{ color: "#fff", fontSize: "1.1rem", marginTop: "1rem" }}>
                                            {screenMsg}
                                        </p>
                                    </div>
                                ) : (
                                    <div className="gameFrameAnimatedBorder" style={{ marginTop: "1.5rem", width: "800px" }}>
                                        <iframe
                                            src={`/JuegoCv/index.html?v=${GAME_VERSION}`}
                                            title="Juego Phaser"
                                            style={{
                                                width: "100%",
                                                height: "600px",
                                                border: "none",
                                                borderRadius: "25px",
                                                display: "block",
                                            }}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </li>
                </ul>
            </div>
            <Modal
                show={!!modalProject}
                onClose={() => setModalProject(null)}
                project={modalProject}
            />
        </>
    );
};

export default Portfolio;
